// Mirror Tabby's actual lowest monthly quote; never estimate it by dividing
// the price or promising an installment schedule that Tabby has not offered.
let observedRoot = null;
let blockedRoot = null;
let quoteObserver = null;
let scheduled = false;
let lastPrice = null;
const notes = () => [...document.querySelectorAll('[data-unbound-monthly-note]')];
const promoRoot = () => document.querySelector('#TabbyPromo span')?.shadowRoot || null;

function clearNotes() {
  for (const note of notes()) {
    const copy = note.querySelector('[data-unbound-monthly-copy]');
    if (!copy) continue;
    const fallback = note.dataset.fallback;
    if (!fallback) continue;
    if (copy.textContent !== fallback) copy.textContent = fallback;
    copy.hidden = false;
  }
}

function syncQuote() {
  const root = promoRoot();
  if (!root || root === blockedRoot) return clearNotes();
  lastPrice = notes()[0]?.dataset.price || lastPrice;
  if (root !== observedRoot) {
    quoteObserver?.disconnect();
    observedRoot = root;
    quoteObserver = new MutationObserver(scheduleSync);
    quoteObserver.observe(root, { childList: true, subtree: true, characterData: true });
  }
  const quote = [...root.querySelectorAll('strong')].map(el => el.textContent || '')
    .find(text => /\/\s*(month|شهر)/i.test(text));
  const amount = quote?.match(/([\d,]+(?:\.\d+)?)\s*\/\s*(?:month|شهر)/i)?.[1];
  if (!amount || !(Number(amount.replaceAll(',', '')) > 0)) return clearNotes();

  for (const note of notes()) {
    const copy = note.querySelector('[data-unbound-monthly-copy]');
    if (!copy) continue;
    const arabic = note.dataset.language === 'ar';
    const strong = document.createElement('strong');
    strong.style.cssText = 'font-weight:800;color:#000';
    strong.textContent = arabic ? amount + ' درهم/شهر' : 'AED ' + amount + '/month';
    const expected = (arabic ? 'ابتداءً من ' : 'As low as ') + strong.textContent;
    if (!copy.hidden && copy.textContent === expected) continue;
    copy.replaceChildren(document.createTextNode(arabic ? 'ابتداءً من ' : 'As low as '), strong);
    copy.hidden = false;
  }
}

function scheduleSync() {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => { scheduled = false; syncQuote(); });
}

document.addEventListener('variant:update', () => {
  const note = notes()[0];
  if (!note) return;
  if (lastPrice === note.dataset.price) return scheduleSync();
  clearNotes();
  blockedRoot = promoRoot();
  lastPrice = note.dataset.price;
  const price = Number(note.dataset.price) / 100;
  if (price > 0) document.dispatchEvent(new CustomEvent('tabby:refresh', { detail: { price } }));
  scheduleSync();
});

// Tabby recreates its container on refresh, so observe container replacement
// as well as changes within its open shadow root.
new MutationObserver(scheduleSync).observe(document.body, { childList: true, subtree: true });
let attempts = 0;
const startup = setInterval(() => {
  scheduleSync();
  if (notes().some(note => note.querySelector('[data-unbound-monthly-copy] strong')) || ++attempts >= 300) clearInterval(startup);
}, 200);
scheduleSync();
